import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import '../stili/Dashboard.css';
import logoDx from '../assets/img/logo_dx.jpg';

const sezioni = [
  {
    titolo: 'Segreteria',
    voci: [
      { label: 'Scheda Genitore', path: '/admin/genitori' },
      { label: 'Aggiorna scheda Genitore', path: '/admin/aggiorna-genitori' },
      { label: 'Scheda Giocatore', path: '/admin/giocatore' },
      { label: 'Aggiorna scheda Giocatore', path: '/admin/aggiorna-giocatori' },
      { label: 'Scheda Staff', path: '/admin/staff' },
      { label: 'Aggiorna scheda Staff', path: '/admin/aggiorna-staff' },
      { label: 'Aggiorna scheda Utente', path: '/admin/aggiorna-utenti' }
    ]
  },
  {
    titolo: 'Contabilità',
    voci: [
      { label: 'Pagamento Quote', path: '/admin/quote' },
      { label: 'Movimenti Cassa', path: '/gestionale/admin/movimenti-cassa' },
      { label: 'Gestione Movimenti Cassa', path: '/gestionale/admin/movimenti-cassa/aggiorna' }
    ]
  },
  {
    titolo: 'Attività',
    voci: [
      { label: 'Programma Gara', path: '/admin/programma-gara' },
      { label: 'Aggiorna Programma Gara', path: '/admin/aggiorna-programmagara' }
    ]
  },
  {
    titolo: 'Comunicazione',
    voci: [
      { label: 'Notizie', path: '/admin/notizie' },
      { label: 'Aggiorna Notizie', path: '/admin/aggiorna-notizie' },
      { label: 'Eventi', path: '/admin/eventi' },
      { label: 'Aggiorna Eventi', path: '/admin/aggiorna-eventi' }
      
    ]
  },
  {
    titolo: 'Report',
    voci: [
      { label: 'Report Iscrizioni', path: '/admin/statistiche' },
      { label: 'Report Presenze Giocatori', path: '/admin/statistiche-presenze' },
      { label: "Documenti Giocatori", path: "/admin/documenti-giocatori" },
      { label: 'Monitoraggio Notifiche Email', path: '/gestionale2/admin/monitoraggio-notifiche-pagamenti' }
    ]
  },
  {
    titolo: 'Sistema',
    voci: [
      { label: 'Categorie', path: '/admin/categorie' },
      { label: 'Scadenza Rate', path: '/admin/scadenze' }      
    ]
  },
{
  titolo: 'Magazzino',
  voci: [
    { label: 'Inserisci Articolo', path: '/gestionale/magazzino' },
    { label: 'Gestione Magazzino', path: '/gestionale/aggiorna-magazzino' },
    { label: 'Registra Acquisto Materiale', path: '/gestionale/acquisto-materiale' },
    { label: 'Gestione Acquisti Materiale', path: '/gestionale/aggiorna-acquisti-materiale' }
  ]
}

];

export default function DashboardAdmin() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [schedaAperta, setSchedaAperta] = useState(null);

  useEffect(() => {
    if (!user?.accessToken) {
      console.warn('⛔ Utente non autenticato. Redirigo al login...');
      navigate('/login');
    }
  }, [user, navigate]);

  if (!user?.accessToken) return null;

  const toggleScheda = (titolo) => {
    setSchedaAperta((prev) => (prev === titolo ? null : titolo));
  };

  return (
    <div className="dashboard-layout">
      <div className="dashboard-content">
        <div className="dashboard-welcome-card">
          <div className="dashboard-welcome-header">
            <h1>Gestionale Segreteria</h1>

            <img
              src={logoDx}
              alt="Logo gestionale"
              className="dashboard-welcome-logo"
            />
          </div>

          <p>Benvenuto nella sezione riservata all&apos;amministratore.</p>
          <p>
            Da qui puoi gestire in modo rapido e ordinato tutte le funzioni principali
            del sistema.
          </p>
        </div>

        <div className="dashboard-cards-grid">
  {sezioni.map((sezione, indexSezione) => {
    const aperta = schedaAperta === sezione.titolo;

    return (
      <article
        key={`${sezione.titolo}-${indexSezione}`}
        className={`dashboard-menu-card ${aperta ? 'open' : ''}`}
      >
        <button
          type="button"
          className="dashboard-menu-card-header"
          onClick={() => toggleScheda(sezione.titolo)}
        >
          <span className="dashboard-menu-card-title">{sezione.titolo}</span>
          <span className={`dashboard-card-caret ${aperta ? 'open' : ''}`} />
        </button>

        {aperta && (
          <div className="dashboard-menu-links">
            {sezione.voci.map((voce, indexVoce) => (
              <button
                key={`${sezione.titolo}-${voce.path}-${indexVoce}`}
                type="button"
                className="dashboard-menu-link"
                onClick={() => navigate(voce.path)}
              >
                {voce.label}
              </button>
            ))}
          </div>
        )}
      </article>
    );
  })}
</div>
      </div>
    </div>
  );
}